"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleChangeSEOCleanURLLocalization = exports.generateLocalizationPath = exports.handleChangeLocalization = exports.handleChangeSPVLanguage = exports.getLanguage = exports.getInitialLocalization = void 0;
var Localization_1 = require("../constants/Localization");
var seoCleanURLHelper_1 = require("./seoCleanURLHelper");
var getInitialLocalization = function () {
    var prefix = location.pathname.split('/')[1];
    var locationPath = getLocationPathName(prefix);
    if (locationPath) {
        return locationPath;
    }
    localStorage.setItem('lang', Localization_1.LocalizationSettings.defaultLanguage);
    return '';
};
exports.getInitialLocalization = getInitialLocalization;
var getLanguage = function () {
    var prefix = location.pathname.split('/')[1];
    var locationPath = getLocationPathName(prefix);
    if (locationPath) {
        return locationPath;
    }
    else {
        localStorage.setItem('lang', Localization_1.LocalizationSettings.defaultLanguage);
    }
    if (location.pathname === '/') {
        return Localization_1.LocalizationSettings.defaultLanguage;
    }
    return localStorage.getItem('lang');
};
exports.getLanguage = getLanguage;
var getLocationPathName = function (prefix) {
    if (Localization_1.LocalizationSettings.appliedLanguage.includes(prefix)) {
        localStorage.setItem('lang', prefix);
        return prefix;
    }
};
var handleChangeSPVLanguage = function (language, id, slug) {
    var href = location.href;
    var split = href.split(location.pathname);
    if (href.includes('announcements')) {
        handleChangePageLanguage(split, language, id, Localization_1.LocalizationSettings.defaultAnnouncement);
    }
    else if (href.includes('wishlist')) {
        handleChangePageLanguage(split, language, id, Localization_1.LocalizationSettings.defaultWishlist);
    }
    else {
        location.replace(split[0] + '/' + language + ("/" + slug[language]));
    }
};
exports.handleChangeSPVLanguage = handleChangeSPVLanguage;
var handleChangePageLanguage = function (split, language, id, type) {
    location.replace(split[0] + '/' + language + type + ("/" + id));
};
var handleChangeLocalization = function (language) {
    var previousLanguage = localStorage.getItem('lang');
    var href = location.href;
    localStorage.setItem('lang', language);
    if (location.pathname.split(language).length === 1 &&
        !location.pathname.split('/').includes(previousLanguage)) {
        var split = href.split(location.pathname);
        if (Object.keys(Localization_1.PagePrefix).includes(location.pathname.split('/')[1])) {
            location.replace(split[0] +
                '/' +
                language +
                ("/" + Localization_1.PagePrefixTranslations[language][previousLanguage][location.pathname.split('/')[1]]) +
                split[1]);
        }
        else {
            location.replace(split[0] + '/' + language + location.pathname + split[1]);
        }
    }
    else {
        var slash = location.pathname.split('/').length === 2 ? '' : '/';
        if (Object.keys(Localization_1.PagePrefix).includes(location.pathname.split('/')[2])) {
            var newHref = translateHref(href, previousLanguage, slash, language, location.pathname.split('/'));
            location.replace(newHref);
        }
        else {
            var newHref = translateHref(href, previousLanguage, slash, language, location.pathname.split('/'));
            location.replace(newHref);
        }
    }
};
exports.handleChangeLocalization = handleChangeLocalization;
var translateHref = function (href, previousLanguage, slash, language, split) {
    var newPathname = '';
    if (href.includes('/account/')) {
        newPathname =
            slash +
                language +
                slash +
                location.pathname.split('/')[2] +
                slash +
                location.pathname.split('/')[3];
    }
    else if (href.includes("" + Localization_1.SearchPagePrefix[previousLanguage][split[2]])) {
        if (previousLanguage === Localization_1.LocalizationSettings.defaultLanguage) {
            newPathname = split[2].length
                ? slash +
                    language +
                    slash +
                    Localization_1.PagePrefixTranslations[language][previousLanguage][split[2]]
                : slash + Localization_1.LanguagePrefix[previousLanguage][language];
        }
        else if (previousLanguage !== Localization_1.LocalizationSettings.defaultLanguage) {
            newPathname = split[2].length
                ? slash +
                    language +
                    slash +
                    Localization_1.PagePrefixTranslations[language][previousLanguage][split[2]]
                : slash + Localization_1.LanguagePrefix[previousLanguage][language];
        }
        else {
            newPathname =
                slash + language + slash + location.pathname.split('/')[2];
        }
    }
    else if (href.includes(previousLanguage + "?")) {
        newPathname = '/' + language + '?' + href.split('/')[3].split('?')[1];
    }
    else {
        newPathname = slash + language + slash + split[2];
    }
    return href.replace(location.pathname, newPathname);
};
var generateLocalizationPath = function (path) {
    return Localization_1.LocalizationSettings.routerPrefix + path;
};
exports.generateLocalizationPath = generateLocalizationPath;
var handleChangeSEOCleanURLLocalization = function (seoCleanLocationSubDirectoryPrefix, previousLanguage, currentLanguage, deal, locationPathName, address) {
    seoCleanURLHelper_1.resolveSeoCleanURL(seoCleanLocationSubDirectoryPrefix, previousLanguage, currentLanguage, deal, locationPathName, address);
};
exports.handleChangeSEOCleanURLLocalization = handleChangeSEOCleanURLLocalization;
